export default __webpack_public_path__ + "static/media/warning--curve-left-with-junction--g1.0bd6a7a9.png";